/**
 * Empty-state prompt suggestions for the report-builder chat. Same visual
 * as `/ask` — the shared `TryAskingList` renders the rounded-card list.
 */
import { AlertCircle, BarChart3, CalendarClock, Wallet } from "lucide-react";
import {
  TryAskingList,
  type TryAskingSuggestion,
} from "../../components/ai-messages/try-asking-list.tsx";

const SUGGESTIONS: readonly TryAskingSuggestion[] = [
  {
    icon: BarChart3,
    title: "Top customers by revenue",
    prompt: "Top 10 customers by revenue in the last 90 days",
  },
  {
    icon: AlertCircle,
    title: "Overdue invoices by state",
    prompt: "Overdue invoices by state, with days overdue",
  },
  {
    icon: Wallet,
    title: "Cash movement this quarter",
    prompt: "Cash movement summary grouped by mode this quarter",
  },
  {
    icon: CalendarClock,
    title: "Upcoming employee joins",
    prompt: "Employees joining next month, by department",
  },
];

interface SuggestedPromptsProps {
  onPick: (prompt: string) => void;
}

export function SuggestedPrompts({ onPick }: SuggestedPromptsProps) {
  return <TryAskingList suggestions={SUGGESTIONS} onSelect={onPick} />;
}
